<template>
    <div class="scroll-wrap" v-bar>
        <div class="container"  ref="scrollBar" id="scrollBar" @scroll="onScroll">
            <div class="article-page" id="article2">
                <div class="closer">
                    <route-item :to="'/main'" :element="'main'"
                                @click.native="gaEvents('article2','click','go down')"></route-item>
                </div>
                <div class="social-share social-block" :class="{'open': openSocial}">
                    <ul class="social-list" v-if="openSocial">
                        <li>
                            <share-link network="fb"
                                url="http://weleda.afisha.ru/share"
                                title="Лимонные ароматы Палермо"
                                image="/static/img/share/share2.jpg"
                                description="Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города."
                                article="/article2"
                                @click.native="gaEvents('article2','click','fb')"
                                class="icon">
                                <fb></fb>
                            </share-link>
                        </li>
                        <li>
                            <share-link network="vk"
                                url="http://weleda.afisha.ru/share"
                                title="Лимонные ароматы Палермо"
                                image="/static/img/share/share2.jpg"
                                description="Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города."
                                article="/article2"
                                @click.native="gaEvents('article2','click','vk')"
                                class="icon">
                                <vk></vk>
                            </share-link>
                        </li>
                        <li>
                            <share-link network="ok"
                                url="http://weleda.afisha.ru/share"
                                title="Лимонные ароматы Палермо"
                                image="/static/img/share/share2.jpg"
                                description="Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города."
                                article="/article2"
                                @click.native="gaEvents('article2','click','ok')"
                                class="icon">
                                <ok></ok>
                            </share-link>
                        </li>
                        <li>
                            <share-link network="tw"
                                url="http://weleda.afisha.ru/share"
                                title="Лимонные ароматы Палермо"
                                image="/static/img/share/share2.jpg"
                                description="Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города."
                                article="/article2"
                                @click.native="gaEvents('article2','click','tw')"
                                class="icon">
                                <tw></tw>
                            </share-link>
                        </li>
                    </ul>
                    <a href="#" class="open-social" @click.prevent="toggleSocial">
                        <p>Поделиться</p>
                        <opensocial></opensocial>
                    </a>
                </div>
                <div class="wrapper">
                    <h2 class="head">
                        Лимонные ароматы Палермо
                    </h2>

                    <div class="video">
                        <div class="video-bg" v-if="!isPlaying"></div>
                        <div class="dplayer-bezel-icon" v-if="!isPlaying" @click="playVideo" ref="button"></div>
                        <youtube player-width="560"
                                 player-height="315"
                                 :video-id="'uT3tKFkRwK4'"
                                 :player-vars="{autoplay: 0,controls: 0, showinfo: 0,rel: 0}"
                                 @ready="ready"
                                 @ended="ended"
                        ></youtube>
                    </div>

                    <div class="quotes">
                        <span class="text">
                            Почти все свое детство я&nbsp;провела в&nbsp;Крыму у&nbsp;бабушки. Часто я&nbsp;помогала ей&nbsp;собирать фрукты для компота.
                            Но&nbsp;вот собирать лимоны на&nbsp;Сицилии для создания органической косметики&nbsp;&mdash; это очень приятный и&nbsp;новый опыт
                        </span>
                    </div>
                    <div class="content">
                        <p>
                            Весь 2018 год Палермо проведет в статусе культурной столицы Италии: эту должность «Орлиный» (так называют административный центр Сицилии итальянцы) вырвал у нескольких древних городов-претендентов прошедшей весной.
                        </p>

                        <p>
                            Действительно, Палермо очень красив: эффектная мешанина готики, барокко и арабской архитектуры, парки со старыми лаврами и инжиром, залитые солнцем набережные Тирренского моря — путеводители советуют заложить на осмотр города не менее пяти дней.
                        </p>

                        <p>
                            Но на деле Палермо всегда был столицей, пусть и очень специальной — итальянских лимонов и всевозможных лимонных удовольствий.
                        </p>

                        <p>
                            Золотые фрукты на Сицилии начали культивировать в XVIII веке.
                            Сначала лимонами занимались монахи иезуитского ордена, потом подхватили остальные: плантации оказались прибыльным бизнесом.
                        </p>

                        <p>
                            На плодородных почвах вокруг Палермо лимон прижился прекрасно: несмотря на то что город отделяет от Этны около четырех часов езды на машине, богатый минералами вулканический пепел долетает сюда легко, в результате многие лимоны под Палермо доживают до ста лет и дают до тонны плодов с дерева в год. Фрукты здесь особые: их отличает значительная кислотность в сочетании с высоким содержанием сахаристых веществ.
                            Отчасти дело в климате и составе почв, во многом — в биодинамических техниках земледелия, которые используются местными лимонными хозяйствами.
                        </p>

                        <p>
                            Те, что заняты в партнерском проекте Weleda, имеют престижный сертификат Demeter, подтверждающий их биодинамический статус: последний означает, что фермерское предприятие прошло трехлетний аудит удобрений, воды и способов возделывания и сбора урожая на подотчетном ему участке.
                        </p>
                    </div>
                </div>
                <div class="slider">
                    <swiper :options="swiperOption">
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article3/slides/slide1.jpg" alt="">
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article3/slides/slide2.jpg" alt="">
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article3/slides/slide3.jpg" alt="">
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article3/slides/slide4.jpg" alt="">
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article3/slides/slide5.jpg" alt="">
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article3/slides/slide6.jpg" alt="">
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article3/slides/slide7.jpg" alt="">
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-button-prev custom-arrow-prev"></div>
                    <div class="swiper-button-next custom-arrow-next"></div>
                </div>

                <div class="wrapper">
                    <div class="quotes">
                        <span class="text">Для меня стало новостью, что урожай лимонов собирают 3 раза в год и созревший лимон не обязательно должен быть желтым, в зависимости от сезона он может оставаться и зеленым</span>
                    </div>

                    <div class="img-content">
                        <div class="img">
                            <img src="static/img/article3/inner-img1.jpg" class="img1" alt="">
                        </div>
                        <div class="desc">
                            <p>
                                Биодинамическое земледелие придумал Рудольф Штайнер, один из основателей клиники антропософской медицины в швейцарском Арлесхайме, откуда выросла компания Weleda.
                                Штайнер верил, что в сельское хозяйство, как и в здоровье человека, нельзя вмешиваться агрессивно — и то и другое нужно синхронизировать с естественными биоритмами природы, привлекая энергии воды, света, земли и воздуха. В лимонных садах Weleda фрукты собирают и сортируют исключительно вручную (к слову, лимонные деревья под Палермо плодоносят круглый год).
                            </p>
                            <p>
                                И в итоге столь бережного отношения местные лимоны — образцовые, сочные, ароматные, и в каждом словно заключен небольшой луч островного солнца, что, конечно, передается косметическим продуктам, которые способны зарядить вас энергией и поднять настроение.
                            </p>
                        </div>
                    </div>

                    <div class="quotes">
                        <span class="text">
                            Во время прогулки по саду Weleda можно сразу посмотреть и на финальный результат сбора лимонов.
                            Фермеры с гордостью показывают цитрусовую линейку косметики от Weleda и рассказывают о ней с огромным интересом
                        </span>
                    </div>

                    <div class="content">
                        <p>
                            Возможно, со стороны биодинамика может показаться сценарием знаменитого фантастического фильма, где недостающим для всеобщего счастья кусочком пазла оказалась искренняя любовь, в данном случае к природе и своему делу, но этот способ работает — дело Штайнера цветет, пахнет и плодоносит.
                        </p>
                    </div>

                    <div class="products-block mobile-hidden">
                        <div class="product-item">
                            <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link-item" @click="gaEvents('longread','click','1-Массажное масло с арникой')"></a>
                            <div class="img">
                                <img src="static/img/product/product4.png" alt="">
                            </div>
                            <span class="item-head">
                                Цитрусовый <br> дезодорант
                            </span>
                            <span class="item-desc">
                                Коктейль бодрости и свежесть 24 часа
                            </span>
                            <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link">
                                <span class="text">
                                    Подробнее
                                </span>
                            </a>
                        </div>
                        <div class="product-item">
                            <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_oil&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link-item" @click="gaEvents('longread','click','2-Цитрусовый освежающий гель для душа')"></a>
                            <div class="img">
                                <img src="static/img/product/product5.png" alt="">
                            </div>
                            <span class="item-head">
                                Цитрусовое <br> освежающее <br> масло для тела
                            </span>
                            <span class="item-desc">
                                Легкое масло с бодрящим ароматом <br> для энергии и тонуса
                            </span>
                            <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_oil&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link">
                                <span class="text">
                                    Подробнее
                                </span>
                            </a>
                        </div>
                        <div class="product-item">
                            <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%BE%D0%BB%D0%BE%D1%87%D0%BA%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_milk&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link-item" @click="gaEvents('longread','click','3-Универсальный питательный крем SKIN FOOD')"></a>
                            <div class="img">
                                <img src="static/img/product/product6.png" alt="">
                            </div>
                            <span class="item-head">
                                Цитрусовое <br> освежающее <br> молочко для тела
                            </span>
                            <span class="item-desc">
                                Легкое молочко для тела <br> с сочным ароматом цитрусов
                            </span>
                            <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%BE%D0%BB%D0%BE%D1%87%D0%BA%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_milk&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link">
                            <span class="text">
                                Подробнее
                            </span>
                            </a>
                        </div>
                    </div>

                    <div class="products-block desktop-hidden">
                        <swiper :options="swiperProductOption">
                            <swiper-slide>
                                <div class="product-item">
                                    <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link-item" @click="gaEvents('longread','click','1-Массажное масло с арникой')"></a>
                                    <div class="img">
                                        <img src="static/img/product/product4.png" alt="">
                                    </div>
                                    <span class="item-head">
                                        Цитрусовый <br> дезодорант
                                    </span>
                                    <span class="item-desc">
                                        Коктейль бодрости и свежесть 24 часа
                                    </span>
                                    <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link">
                                        <span class="text">
                                            Подробнее
                                        </span>
                                    </a>
                                </div>
                            </swiper-slide>
                            <swiper-slide>
                                <div class="product-item">
                                    <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_oil&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link-item" @click="gaEvents('longread','click','2-Цитрусовый освежающий гель для душа')"></a>
                                    <div class="img">
                                        <img src="static/img/product/product5.png" alt="">
                                    </div>
                                    <span class="item-head">
                                        Цитрусовое <br> освежающее <br> масло для тела
                                    </span>
                                    <span class="item-desc">
                                        Легкое масло с бодрящим ароматом <br> для энергии и тонуса
                                    </span>
                                    <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_oil&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link">
                                        <span class="text">
                                            Подробнее
                                        </span>
                                    </a>
                                </div>
                            </swiper-slide>
                            <swiper-slide>
                                <div class="product-item">
                                    <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%BE%D0%BB%D0%BE%D1%87%D0%BA%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_milk&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link-item" @click="gaEvents('longread','click','3-Универсальный питательный крем SKIN FOOD')"></a>
                                    <div class="img">
                                        <img src="static/img/product/product6.png" alt="">
                                    </div>
                                    <span class="item-head">
                                        Цитрусовое <br> освежающее <br> молочко для тела
                                    </span>
                                    <span class="item-desc">
                                        Легкое молочко для тела <br> с сочным ароматом цитрусов
                                    </span>
                                    <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%BE%D0%BB%D0%BE%D1%87%D0%BA%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_milk&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link">
                                        <span class="text">
                                            Подробнее
                                        </span>
                                    </a>
                                </div>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
                <div class="check">
                    <div class="footnote"><p>*Веледа,Ролл-он</p></div>
                    <router-link to="/article3" class="btn" @click.native="gaEvents('main','click','go to longread 3')">
                        Далее
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import  articleMix from '@/components/pages/articles/article_mix.vue';
    import DPlayer from 'DPlayer';

    export default {
        name: 'article2',
        mixins: [articleMix],
        data() {
            return {
                isPlaying: false,
                player: ''
            }
        },
        methods: {
            ready(e) {
                this.canPlay = true;
                this.player = e.target;
            },
            ended() {
                this.isPlaying = false;
            },
            playVideo() {
                this.isPlaying = true;
                if(this.canPlay){
                    this.$root.gaSend('play','click','longread 2')
                    this.player.playVideo();
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// article2.vue?116f5cde